// Categorías por género (Opción B): cada categoría tiene variante Hombre / Mujer / Unisex
// donde aplica. Las que no tienen sentido por género se mantienen como una sola entrada.
export const CATEGORIES = [
    // Perfumes
    "Perfumes Hombre",
    "Perfumes Mujer",
    "Perfumes Unisex",
    // Cuidado personal
    "Maquillaje Mujer",
    "Cuidado de la piel Hombre",
    "Cuidado de la piel Mujer",
    "Cuidado del cabello Hombre",
    "Cuidado del cabello Mujer",
    // Ropa
    "Ropa Hombre",
    "Ropa Mujer",
    "Ropa Niño",
    "Ropa Niña",
    "Ropa interior Hombre",
    "Ropa interior Mujer",
    "Ropa deportiva Hombre",
    "Ropa deportiva Mujer",
    // Calzado
    "Calzado Hombre",
    "Calzado Mujer",
    "Calzado Niño",
    "Calzado Niña",
    // Accesorios y joyería
    "Accesorios Hombre",
    "Accesorios Mujer",
    "Accesorios Unisex",
    "Joyería Hombre",
    "Joyería Mujer",
    "Bolsos Mujer",
    "Bolsos Hombre",
    // Otros
    "Regalos",
    "Otros",
];

// English display labels for each backend category key. Used to translate
// the visible <option> text on the US/EN site while keeping the value as
// the Spanish key expected by the backend. Also used by ProductCard as a
// fallback when a product's `categoria_en` isn't populated by the AI translator.
export const CATEGORY_LABELS_EN = {
    "Perfumes Hombre": "Men's Cologne",
    "Perfumes Mujer": "Women's Perfume",
    "Perfumes Unisex": "Unisex Fragrance",
    "Maquillaje Mujer": "Makeup",
    "Cuidado de la piel Hombre": "Men's Skincare",
    "Cuidado de la piel Mujer": "Women's Skincare",
    "Cuidado del cabello Hombre": "Men's Hair Care",
    "Cuidado del cabello Mujer": "Women's Hair Care",
    "Ropa Hombre": "Men's Clothing",
    "Ropa Mujer": "Women's Clothing",
    "Ropa Niño": "Boys' Clothing",
    "Ropa Niña": "Girls' Clothing",
    "Ropa interior Hombre": "Men's Underwear",
    "Ropa interior Mujer": "Women's Underwear",
    "Ropa deportiva Hombre": "Men's Activewear",
    "Ropa deportiva Mujer": "Women's Activewear",
    "Calzado Hombre": "Men's Shoes",
    "Calzado Mujer": "Women's Shoes",
    "Calzado Niño": "Boys' Shoes",
    "Calzado Niña": "Girls' Shoes",
    "Accesorios Hombre": "Men's Accessories",
    "Accesorios Mujer": "Women's Accessories",
    "Accesorios Unisex": "Unisex Accessories",
    "Joyería Hombre": "Men's Jewelry",
    "Joyería Mujer": "Women's Jewelry",
    "Bolsos Mujer": "Women's Bags",
    "Bolsos Hombre": "Men's Bags",
    "Regalos": "Gifts",
    "Otros": "Other",
};

export const categoryLabel = (key, isEnglish) => {
    if (!isEnglish) return key;
    return CATEGORY_LABELS_EN[key] || key;
};
